import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

/* Layout */
import { LOGIN } from '../store/mutation-types';
// 路由懒加载 https://router.vuejs.org/zh-cn/advanced/lazy-loading.html
// 错误页面
const Err404 = () => import('@/components/base/errorPage/404');
const Err401 = () => import('@/components/base/errorPage/401');

// 登录页面
const Index = () => import('@/views/index/index');
const Project = () => import('@/views/project/project');
const Vshare = () => import('@/views/project/vshare/vshare');
const Vgrass = () => import('@/views/project/vgrass/vgrass');
const Miya = () => import('@/views/project/miya/miya');
const Qy = () => import('@/views/project/qy/qy');
const Box = () => import('@/views/project/box/box');
const Jhjk = () => import('@/views/project/jhjk/jhjk');
const Ams = () => import('@/views/project/ams/ams');
// fix Lazy loading routes Error: Cyclic dependency [https://github.com/vuejs/vue-cli/issues/1669]
// 使用懒加载方式引入以下两个页面组件（两个页面引入了业务通用组件Order）时报错，其中一个通过require方式引入可以绕过这个问题

/** *****************RAM BEGIN*******************/

export const constantRouterMap = [
  { path: '/404', component: Err404, hidden: true },
  { path: '/401', component: Err401, hidden: true },
  {
    path: '',
    component: Index,
    name: 'Index',
    meta: {
      title: '首页',
      footer: true
      // perm: 'Mgr.Dashboard'
    }
  },
  {
    path: '/projects',
    component: Project,
    name: 'Project',
    meta: {
      title: '案例'
      // perm: 'Mgr.Dashboard'
    }
  },
  {
    path: '/vshare',
    component: Vshare,
    name: 'Vshare',
    meta: {
      title: '推品牌'
      // perm: 'Mgr.Dashboard'
    }
  },
  {
    path: '/vgrass',
    component: Vgrass,
    name: 'Vgrass',
    meta: {
      title: 'VGRASS'
      // perm: 'Mgr.Dashboard'
    }
  },
  {
    path: '/miya',
    component: Miya,
    name: 'Miya',
    meta: {
      title: '仕品'
      // perm: 'Mgr.Dashboard'
    }
  },
  {
    path: '/qy',
    component: Qy,
    name: 'Qy',
    meta: {
      title: '企运'
      // perm: 'Mgr.Dashboard'
    }
  },
  {
    path: '/box',
    component: Box,
    name: 'Box',
    meta: {
      title: '酒店盒子'
      // perm: 'Mgr.Dashboard'
    }
  },
  {
    path: '/jhjk',
    component: Jhjk,
    name: 'Jhjk',
    meta: {
      title: '金海智慧社区'
      // perm: 'Mgr.Dashboard'
    }
  },
  {
    path: '/ams',
    component: Ams,
    name: 'Ams',
    meta: {
      title: 'AMS资产管理'
      // perm: 'Mgr.Dashboard'
    }
  },

  /*************************************以下为业务相关路由*****************************************/
  { path: '*', redirect: '/404', hidden: true }
];

export default new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});

// export const asyncRouterMap = [];
